export type ComposerVideoPreviewSource = {
    contentType: string
    typedSourceSrc: string | undefined
    videoSrc: string | undefined
}

export function resolveComposerVideoPreviewSource(
    videoUrl: string,
    contentType?: string | null,
): ComposerVideoPreviewSource {
    const resolvedContentType = contentType || 'video/mp4'
    const shouldSniffQuickTimePreview = resolvedContentType === 'video/quicktime'

    return {
        contentType: resolvedContentType,
        typedSourceSrc: shouldSniffQuickTimePreview ? undefined : videoUrl,
        videoSrc: shouldSniffQuickTimePreview ? videoUrl : undefined,
    }
}

export function resolveOptimisticVideoPreviewSource(
    videoUrl: string | null,
    shouldPrimePreview: boolean,
): string | null {
    return videoUrl && shouldPrimePreview ? `${videoUrl}#t=0.1` : videoUrl
}

export function resetOptimisticVideoPreviewTime(
    video: { currentTime: number },
    shouldPrimePreview: boolean,
): void {
    if (shouldPrimePreview) video.currentTime = 0
}
